import cn from 'classnames';

import CloseImg from '@publicImages/svg/close.svg?icon';

const Close = ({ className = '', id = 'close', ...restProps }) => (
  <CloseImg className={cn('Close', className)} id={id} {...restProps} />
);

export default Close;
